export default "__VITE_ASSET__030516a6__"